import React from 'react';
import { Card, CardContent } from './ui/card';
import { Phone, Calendar, Wrench, CheckCircle } from 'lucide-react';

const Process = () => {
  const steps = [
    {
      icon: Phone,
      number: '01',
      title: 'Hubungi Kami',
      description: 'Konsultasi gratis via WhatsApp, jelaskan masalah kompor Anda'
    },
    {
      icon: Calendar,
      number: '02',
      title: 'Jadwalkan Kunjungan',
      description: 'Teknisi kami akan datang sesuai waktu yang Anda tentukan'
    },
    {
      icon: Wrench,
      number: '03',
      title: 'Proses Perbaikan',
      description: 'Diagnosa akurat dan perbaikan dengan spare part original'
    },
    {
      icon: CheckCircle,
      number: '04',
      title: 'Garansi & Selesai',
      description: 'Kompor berfungsi normal dengan garansi service terjamin'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-block bg-blue-100 text-blue-600 px-4 py-2 rounded-full text-sm font-semibold mb-4">
            Proses Mudah
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Cara Kerja Kami
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            4 langkah sederhana untuk water heater Anda kembali berfungsi sempurna
          </p>
        </div>

        {/* Process Steps */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 relative">
          {/* Connection Lines */}
          <div className="hidden lg:block absolute top-20 left-0 right-0 h-1 bg-gradient-to-r from-blue-200 via-blue-300 to-blue-200" style={{ width: 'calc(100% - 8rem)', margin: '0 4rem' }}></div>

          {steps.map((step, index) => {
            const Icon = step.icon;
            return (
              <Card key={index} className="relative border-2 border-gray-200 hover:border-blue-500 hover:shadow-xl transition-all duration-300 group">
                <CardContent className="p-6 text-center">
                  {/* Number Badge */}
                  <div className="absolute -top-6 left-1/2 transform -translate-x-1/2 bg-blue-600 text-white w-12 h-12 rounded-full flex items-center justify-center text-xl font-bold shadow-lg group-hover:scale-110 transition-transform duration-300">
                    {step.number}
                  </div>

                  {/* Icon */}
                  <div className="bg-blue-100 w-16 h-16 rounded-2xl flex items-center justify-center mx-auto mb-4 mt-6 group-hover:bg-blue-600 transition-colors duration-300">
                    <Icon className="w-8 h-8 text-blue-600 group-hover:text-white transition-colors duration-300" />
                  </div>

                  {/* Content */}
                  <h3 className="text-xl font-bold text-gray-900 mb-2">{step.title}</h3>
                  <p className="text-gray-600 leading-relaxed">{step.description}</p>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Process;